import { KrChip } from '@/common/card/KrChip';

export const BooleanCellRenderer = ({ value }) => {
  if (value == null) return <span />;

  if (value === 'Y' || value === true || value === 'TRUE') {
    return <KrChip label="Yes" color="green" />;
  } else {
    return <KrChip label="No" color="gray" />;
  }
};
